export default function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
